import { ReduxService } from 'dashboard-services/services';

import { basicListDataStorageActions as basicActions } from 'actions/modules/dataStorage/list';

export const basicInitialState = {
  selectedDp: undefined,
  selectedDpVersion: undefined,
  detailsMenuTab: basicActions.DP_DETAILS_TABS.DETAILS
}

export default (state = basicInitialState, action) => {
  switch (action.type) {
    case basicActions.ON_CHANGE: {
      if(state[action.name] !== action.value) {
        return ReduxService.updateObject(state, { [action.name]: action.value })
      }
      return state;
    }
    default:
      return state;
  }
}